import React from 'react';
import uuid from 'uuid/v4';
import {matchKeywords} from './StringUtils';
import {eventTypesEnum} from '../components/general/EventTypeSelector';
import {Region} from '../models/territory';

export function hexify(color) {
  const values = color
      .replace(/rgba?\(/, '')
      .replace(/\)/, '')
      .replace(/[\s+]/g, '')
      .split(',');
  const a = parseFloat(values[3] || 1);
  const r = Math.floor(a * parseInt(values[0]) + (1 - a) * 255);
  const g = Math.floor(a * parseInt(values[1]) + (1 - a) * 255);
  const b = Math.floor(a * parseInt(values[2]) + (1 - a) * 255);
  return '' +
      ('0' + r.toString(16)).slice(-2) +
      ('0' + g.toString(16)).slice(-2) +
      ('0' + b.toString(16)).slice(-2);
}

export const colors = {
  asoKeywordsMain: '#6DE5B9',
  asoKeywordsMainSecond: '#C9E5DA',
  asoKeywordsAdditional: '#4598ef',
  asoKeywordsAdditionalSecond: '#98c5f5',
  asoKeywordsOld: '#E56D99',
  asoKeywordsOldSecond: '#f0afc6',

  asoKeywordsSub1: '#c56de5',
  asoKeywordsSub1Second: '#cea0e9',
  asoKeywordsSub2: '#45a43e',
  asoKeywordsSub2Second: '#679f63',
  asoKeywordsSub3: '#e2e91a',
  asoKeywordsSub3Second: '#dee58f',

  asoKeywordsFind: '#90caf9',

  keywordsDetailsActive: '#42a5f5',
  keywordsDetailsUnActive: '#90caf9',

  keywordHideActive: '#1de9b6',
  keywordHideUnActive: '#dadada',

  defSwitcherActive: '#00CCCC',
  defSwitcherUnActive: '#E4EAF0',
};

export const getGradientAso = (isMain, isAdditional, isOld, isSub_1, isSub_2, isSub_3) => {
  const formsColors = [
    {isForm: isMain, color: colors.asoKeywordsMain},
    {isForm: isAdditional, color: colors.asoKeywordsAdditional},
    {isForm: isOld, color: colors.asoKeywordsOld},
    {isForm: isSub_1, color: colors.asoKeywordsSub1},
    {isForm: isSub_2, color: colors.asoKeywordsSub2},
    {isForm: isSub_3, color: colors.asoKeywordsSub3},
  ];

  let countTrueForms = -1;
  formsColors.forEach((formColor) => {
    if (formColor.isForm) {
      countTrueForms++;
    }
  });
  const step = Number(Number(100 / (countTrueForms === 0 ? 1 : countTrueForms)).toFixed(0));
  let gradient = 'linear-gradient(90deg';
  let currentStep = 0;
  formsColors.forEach((formColor) => {
    if (formColor.isForm) {
      if (countTrueForms === 0) {
        gradient += `, ${formColor.color} 0%, ${formColor.color} 100%`;
      } else {
        gradient += `, ${formColor.color} ${currentStep}%`;
        currentStep += step;
      }
    }
  });
  gradient += ')';
  return gradient;
};

export const getAreaMetricsGradient = (color, id) => {
  return <svg style={{height: 0}}>
    <defs>
      <linearGradient id={id}
        x1="0%"
        y1="0%"
        x2="0%"
        y2="100%"
      >
        <stop offset="0%" stopColor={color}/>
        <stop offset="99%" stopColor="#FFFFFFFF"/>
      </linearGradient>
    </defs>
  </svg>;
};

export const phrasesColored = (phrases, phrasesExceededLimit = [], formsWords) => {
  const mapMatch = {};
  let res = phrases;
  phrasesExceededLimit.forEach((phrase) => {
    const id = uuid();
    const style = `"background-color: #ce93d8"`;
    mapMatch[id] = `<span style=${style}>${phrase}</span>`;

    res = res.replaceAll(phrase, id);
  });
  if (Object.keys(formsWords).length > 0) {
    res = matchKeywords(res, formsWords);
  }

  Object.keys(mapMatch).forEach((match) => {
    res = res.replaceAll(match, mapMatch[match]);
  });

  return res;
};

export const selectStyles = (props = {}) => {
  return {
    container: (base, state) => {
      const container = props.container ? props.container(base, state) : {};
      return {
        ...base, ...{...{zIndex: 1, borderColor: (state.isFocused ? '#E4EAF0' : '#E4EAF0'), ...container}},
      };
    },
    control: (base, state) => {
      const control = props.control ? props.control(base, state) : {};

      return {
        ...base, ...{...{
          'transition': '.5s',
          'boxShadow': 'none',
          'borderColor': (state.isFocused ? '#00CCCC' : '#E4EAF0'),
          '&:hover': {
            cursor: 'pointer',
            border: '1px solid #00CCCC',
          },
          '&:focus': {
            outline: 'none',
          },
        },
        ...control}};
    },
    option: (base, state) => ({
      ...base, ...{
        'display': 'flex',
        'transition': '.5s',
        'fontSize': 14,
        'textAlign': 'center',
        'backgroundColor': (state.isSelected ? '#00CCCC' : state.isFocused ? 'rgba(0, 204, 204, 0.1)' : 'white'),
        'borderBottom': state.data.isLastGeneral ? '#8a8a8a solid 2px' : undefined,
        '&:hover': {
          cursor: 'pointer',
        },
      },
    }),
    menuList: (base, state) => ({
      ...base, ...{
        margin: 0,
        padding: 0,
        borderRadius: '4px',
      },
    }),
    indicatorSeparator: (base) => ({
      ...base, ...{width: '0px'},
    }),
    clearIndicator: (base) => ({
      ...base, ...{color: '232326'},
    }),
    dropdownIndicator: (base) => ({
      ...base, ...{color: '#232326'},
    }),
    placeholder: (base) => ({
      ...base, ...{color: '#232326'},
    }),
    multiValue: (base) => ({
      ...base, ...{backgroundColor: '#E4EAF0', height: 24, borderRadius: '4px'},
    }),
    multiValueLabel: (base) => ({
      ...base, ...{borderRadius: '4px', padding: 0, paddingLeft: '3px', height: 24, display: 'flex', alignItems: 'center'},
    }),
  };
};

export const countryColor = {[Region['China, Singapore']]: '#ef5350', [Region['UK, Ireland']]: '#66bb6a', [Region['Germany, Austria']]: '#fb8c00', [Region['Arabic world']]: '#795548', [Region['Russia, Ukraine']]: '#ffeb3b', [Region['Australia, New Zealand']]: '#42a5f5', [Region['Hong Kong, Taiwan, Macau']]: '#546e7a', [Region['Hispanic America']]: '#e64a19', [Region['Netherlands, Suriname']]: '#ab47bc', [Region['Croatia, Bosnia and Herzegovina, Montenegro, Serbia']]: '#00acc1',
  'other': '#e4eaf0', 'AF': '#be0d66', 'AL': '#dc2e90', 'DZ': '#dd6442', 'AS': '#7f122', 'AD': '#ff7591', 'AO': '#e3b3dd', 'AI': '#1fde7b', 'AG': '#2cd7f', 'AR': '#fd54e2', 'AM': '#4e8a41', 'AW': '#cb70a8', 'AU': '#bb6997', 'AT': '#2338b0', 'AZ': '#1848c6', 'BS': '#b41f6e', 'BH': '#2dd232', 'BD': '#da0e21', 'BB': '#c08a05', 'BY': '#f0e2d0', 'BE': '#8d50ec', 'BZ': '#5eba4f', 'BJ': '#10199', 'BM': '#a0b185', 'BT': '#8f31b7', 'BO': '#8ae1a', 'BA': '#608891', 'BW': '#dfb3ce', 'BR': '#db34b9', 'VG': '#9ae45e', 'BN': '#f9b152', 'BG': '#f4f81e', 'BF': '#24a4c', 'BI': '#fb61f', 'KH': '#e27ea2', 'CM': '#3c2663', 'CA': '#75046a', 'CV': '#4b2551', 'KY': '#11b762', 'CF': '#51ace', 'TD': '#82d884', 'CL': '#ac1c7b', 'CN': '#7922ba', 'CX': '#22a0c5', 'CC': '#ea34d4', 'CO': '#42243e', 'KM': '#b4926d', 'CG': '#adb02a', 'CK': '#5d1710', 'CR': '#bd9025', 'CI': '#40ca20', 'HR': '#4ab3e7', 'CU': '#47af86', 'CY': '#6cc996', 'CZ': '#a0ebfe', 'DK': '#dda6bf', 'DJ': '#863545', 'DM': '#60e004', 'DO': '#821366', 'EC': '#89bd7e', 'EG': '#d82430', 'SV': '#56f781', 'GQ': '#917f37', 'ER': '#2dd463', 'EE': '#8e6211', 'ET': '#657463', 'FK': '#f51680', 'FO': '#8b03d7', 'FJ': '#7493db', 'FI': '#97f2f2', 'FR': '#fa4d25', 'GF': '#52f8b6', 'PF': '#108fbf', 'GA': '#3a47c', 'GM': '#d3ba32', 'GE': '#f13201', 'DE': '#71bc52', 'GH': '#ac8821', 'GI': '#4b2fc8', 'GR': '#4a6469', 'GL': '#ad4b7a', 'GD': '#5ab64b', 'GP': '#6cf640', 'GU': '#40b964', 'GT': '#adb49a', 'GN': '#334097', 'GW': '#3a2f15', 'GY': '#c8c6be', 'HT': '#ecda47', 'VA': '#1376ac', 'HN': '#d756fb', 'HU': '#4b6d84', 'IS': '#2f947', 'IN': '#c81eb2', 'ID': '#6524bc', 'IR': '#ef403f', 'IQ': '#8afbaf', 'IE': '#4dbd3a', 'IL': '#cb75c5', 'IT': '#5cfb57', 'JM': '#f14d67', 'JP': '#336479', 'JO': '#24ece7', 'KZ': '#9d5f40', 'KE': '#ecfa97', 'KI': '#dc6f90', 'KP': '#317b91', 'KR': '#269503', 'KW': '#be4514', 'KG': '#4908e1', 'LA': '#cfa535', 'LV': '#58865d', 'LB': '#304489', 'LS': '#4b1135', 'LR': '#847777', 'LY': '#135ee1', 'LI': '#c85405', 'LT': '#aef1fa', 'LU': '#4d8b10', 'MK': '#8f4cd2', 'MG': '#96d69c', 'MW': '#d2c900', 'MY': '#5690a1', 'MV': '#29b1c9', 'ML': '#e170a0', 'MT': '#b5258a', 'IM': '#81b133', 'MH': '#8324be', 'MQ': '#e8df1e', 'MR': '#e1d038', 'MU': '#97f6b7', 'YT': '#1d557e', 'MX': '#1a1047', 'FM': '#349b66', 'MD': '#3a990d', 'MC': '#44927a', 'MN': '#ca8c02', 'MS': '#60cd93', 'MA': '#30f5b1', 'MZ': '#f3739a', 'MM': '#b2893e', 'NA': '#d0741a', 'NR': '#7ba21d', 'NP': '#c118be', 'NL': '#95e0ab', 'AN': '#433aa5', 'NC': '#3f0039', 'NZ': '#d3265a', 'NI': '#72c3d6', 'NE': '#b2f9fb', 'NG': '#44609c', 'NU': '#3824e3', 'NF': '#c3d85c', 'MP': '#34b267', 'NO': '#ad34e2', 'OM': '#bd5da1', 'PK': '#abca8c', 'PW': '#11118b', 'PS': '#a67c03', 'PA': '#3afc48', 'PG': '#6c4393', 'PY': '#61a566', 'PE': '#e39ec0', 'PH': '#9a3ffd', 'PN': '#46dbd0', 'PL': '#813d3a', 'PT': '#d78401', 'PR': '#1e719e', 'QA': '#aafc9e', 'RE': '#c3cd6c', 'RO': '#d8545a', 'RU': '#d51746', 'RW': '#2632c8', 'KN': '#a40694', 'LC': '#39d80d', 'PM': '#e7d3aa', 'VC': '#6c9b7e', 'SM': '#abaefd', 'ST': '#2d0f01', 'SA': '#afeea1', 'SN': '#9b033b', 'SC': '#fd18ae', 'SL': '#270324', 'SG': '#fcc2e7', 'SK': '#ff26f1', 'SI': '#74436a', 'SB': '#b1408f', 'SO': '#27e2bb', 'ZA': '#3169e3', 'ES': '#9dbcfe', 'LK': '#6868bf', 'SD': '#7cff2e', 'SR': '#9b6ec', 'SJ': '#c91cab', 'SZ': '#75da18', 'SE': '#e3177d', 'CH': '#3a2089', 'SY': '#48a720', 'TW': '#a9b7a1', 'TJ': '#6df382', 'TZ': '#b81416', 'TH': '#17ddd7', 'TG': '#4f3b75', 'TK': '#470d21', 'TO': '#e9c384', 'TT': '#921c91', 'TN': '#3894d0', 'TR': '#cc7978', 'TM': '#68a66a', 'TC': '#efc3b9', 'TV': '#df4aad', 'UG': '#97f28a', 'UA': '#13598a', 'AE': '#e62a53', 'GB': '#bdbe0d', 'US': '#40916c', 'UM': '#b0d7ff', 'UY': '#7dd7ff', 'UZ': '#4b0d16', 'VU': '#c8e49b', 'VE': '#a78b89', 'VN': '#e68c8c', 'VI': '#6575a1', 'WF': '#697ddb', 'EH': '#600fd4', 'WS': '#ad043', 'YE': '#ce7ee4', 'CD': '#f25519', 'ZM': '#783298', 'ZW': '#82c745', 'HK': '#3654c3', 'MO': '#2584d4', 'AQ': '#f6b978', 'BV': '#a30f54', 'IO': '#4473ab', 'TF': '#2d6e5f', 'HM': '#cabdfe', 'SH': '#d53001', 'GS': '#fb46ae', 'GG': '#871d88', 'RS': '#325ae2', 'BL': '#ef187b', 'ME': '#e05b23', 'JE': '#8b5ab6', 'CW': '#38ac78', 'MF': '#41a039', 'SX': '#5d6bfd', 'TL': '#dd452c', 'SS': '#34e32b', 'AX': '#ba5905', 'BQ': '#a6268', 'XK': '#4234e1'};
